import { useState, useEffect } from "react";
import { FileClock } from "lucide-react";
import DataTable from "@/components/DataTable";
import { Button } from "@/components/ui/button";
import { getTransactions } from "@/api/transactions";
// import { STORAGE_KEYS, getFromStorage } from "@/utils/storage";
// import appData from '@/data/appData.json';

const columns = [
  { header: "Kullanıcı ID", accessor: "user_id" },
  { header: "Uygulama", accessor: "app_id" },
  { header: "İşlem ID", accessor: "id" },
  { header: "Cüzdan Adresi", accessor: "wallet_address" },
  { header: "İşlem", accessor: "process" },
  { header: "Tutar", accessor: "amount" },
  { header: "Tarih", accessor: "date" },
];

export default function TransactionHistory() {
  const [allTransactions, setAllTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    getTransactions()
      .then((response) => {
        const txs = Array.isArray(response.data)
          ? response.data
          : response.data?.body?.result || response.data?.body || [];
        setAllTransactions(txs);
        setError("");
      })
      .catch((err) => setError("İşlem verileri alınamadı."))
      .finally(() => setLoading(false));
  }, []);

  const handleRefresh = () => window.location.reload();

  const sortedTransactions = [...allTransactions].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  if (loading) return <div className="p-6 ml-8">Yükleniyor...</div>;
  if (error) return <div className="p-6 ml-8 text-red-500">{error}</div>;

  return (
    <div className="p-6 ml-8">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <FileClock />
          <h1 className="text-2xl font-bold">İşlem Geçmişi</h1>
        </div>
        <Button variant="refresh" onClick={handleRefresh} />
      </div>

      {allTransactions.length === 0 ? (
        <div className="flex items-center justify-center p-8 bg-gray-50 rounded-lg">
          <p className="text-gray-500">Herhangi bir işlem yapılmamış.</p>
        </div>
      ) : (
        <DataTable
          data={sortedTransactions}
          columns={columns}
          caption="Geçmiş işlemler listesi"
          itemsPerPage={5}
          isAddButtonEnabled={false}
        />
      )}
    </div>
  );
}
